import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { Clipboard } from '@ionic-native/clipboard';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { TranslateService } from '@ngx-translate/core';
import { RmtSnackbarComponent } from '../../components/rmt-snackbar/rmt-snackbar';

@Component({
  selector: 'rmt-clipboard-container',
  templateUrl: 'rmt-clipboard-container.html'
})
export class RmtClipboardContainerComponent {
  @ViewChild('content', { read: ElementRef }) content;
  @Input() successText: string = '';
  @Input() copyText: string = '';
  @Input() iconSrc: string = 'assets/icons/copy.svg';
  canShowCopyIcon = false;
  constructor(private clipboard: Clipboard, private translate: TranslateService,) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.content && this.content.nativeElement && this.content.nativeElement.innerText !== '') {
        this.canShowCopyIcon = true;
      }
    }, 100);
  }

  async onCopyClick() {
    await this.clipboard.copy(this.copyText || this.content.nativeElement.innerText);
    var message = this.translate.instant('page.sendCompletedPage.clipboardText');
    if (this.successText !== "") {
      message = this.successText;
    }
    RmtSnackbarComponent.present(message);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-clipboard-container/rmt-clipboard-container.ts